import { useState } from 'react';

import { CounterClockwiseClockIcon } from '@radix-ui/react-icons';
import { IconButton, Popover, Tooltip } from '@raystack/apsara';
import clsx from 'clsx';

import { HEADER_ICON_COLOR } from '@src/components/Custom/Header/Header';

import { HistoryList } from './HistoryList';

import styles from './History.module.css';

export const HistoryPopover = () => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <Popover.Trigger asChild>
        <IconButton
          size={3}
          data-test-id='chat-history'
          className={clsx({ [styles.buttonActive]: open })}
        >
          <Tooltip message='Chat History' side='bottom'>
            <CounterClockwiseClockIcon color={HEADER_ICON_COLOR} />
          </Tooltip>
        </IconButton>
      </Popover.Trigger>
      <Popover.Content
        align='end'
        side='bottom'
        sideOffset={4}
        avoidCollisions={true}
        className={styles.historyPopoverContent}
      >
        <HistoryList closePopover={() => setOpen(false)} />
      </Popover.Content>
    </Popover>
  );
};
